import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { ConfigurationsService, ModalService, PriceDetailsComponent, ProductFeaturesComponent, StepComponent } from '@icc/configurator/shared';
import { ConstructionParametersComponent } from '../construction-parameters/construction-parameters.component';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { UserService } from "@icc/shared/core";

@Component({
    selector: 'icc-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent extends StepComponent implements OnInit {
    static stepName = _('CONFIGURATOR|Szczegóły');
    static stepIcon = {
        ligature: 'remove_red_eye',
    };

    public configurator = 'window';
    public stepId = 'details';
    public title = _('CONFIGURATOR|Szczegóły');
    public options = [
        {
            title: _('WINDOW|Parametry Uw/Sw'),
            component: ConstructionParametersComponent,
            componentData: {
                conf: () => this.configurationsService.conf.Current
            },
            show: () => this.showParametersModal
        },
        {
            title: _('CONFIGURATOR|Porównanie linii'),
            callback: () => this.openSystemsComparision(),
            show: () => this.showSystemsComparision
        },
        {
            title: _('CONFIGURATOR|Szczegóły wyceny'),
            component: PriceDetailsComponent,
            show: () => this.showPriceDetails
        },
        {
            title: _('CONFIGURATOR|Cechy produktów'),
            component: ProductFeaturesComponent,
            show: () => this.showProductFeatures
        }
    ]

    details: any = {};
    priceElementsVisible = false;
    showParametersModal = false;
    showPriceDetails = false;
    showSystemsComparision = false;
    showProductFeatures = true;

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private modalService: ModalService,
        private configurationsService: ConfigurationsService<'window' | 'door'>,
        private userService: UserService
    ) {
        super();
    }

    ngOnInit() {
        const user = this.userService.get();
        this.showParametersModal = this.config().IccConfig.Configurators.showParametersModal;
        this.showPriceDetails = this.config().IccConfig.Configurators.showPriceDetails && user.access == 'producent' && !this.userService.b2c;
        if(this.config().preset === 'b2c') {
            this.showParametersModal = this.config().IccConfig.Configurators.showParametersModalB2C;
            this.showProductFeatures = this.config().IccConfig.Configurators.showProductFeaturesModalB2C;
        }
    }

    openPriceDetails() {
        this.modalService.open({
            pageComponent: PriceDetailsComponent,
        });
    }

    openSystemsComparision() {
    }

}
